import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自追剧伙伴们的真实反馈，来看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-950 truncate">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="mt-3 pt-3 border-t border-background-200/60">
                <span className="inline-flex items-center gap-1 text-xs text-primary-400 font-medium">
                  <i className="ri-chat-quote-line"></i>
                  正在追 {comment.drama}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}